import { useRouter } from 'vue-router';

import useIsCurrentUserCanViewFacebook from './useIsCurrentUserCanViewFacebook';

export default function useFacebookPageRouterGuard() {
  const router = useRouter();

  const isCurrentUserCanViewFacebook = useIsCurrentUserCanViewFacebook();

  router.beforeEach((to, _, next) => {
    if (to.name !== 'facebook') {
      next();
      return;
    }

    if (!isCurrentUserCanViewFacebook.value) {
      next({ name: 'campaigns' });
      return;
    }

    next();
  });
}
